module.exports = __webpack_public_path__ + "static/media/logo_bg.aba99790.svg";